<template id="eventDialog">
  <v-dialog persistent v-model="getDialog" max-width="1200">
      <v-card>
        <v-card-title class="headline">Detail Event</v-card-title>

        <v-card-text v-if="getData">
          <ul class="event_meta">
            <li>time : {{ getData.time }}</li>
            <li>from : {{ getData.from }}</li>
            <li>to : {{ getData.to }}</li>
            <li :class="{event_ok: getData.status == 'ok', event_error: getData.status == 'error', event_warning : getData.status == 'warning', event_info: getData.status == 'info'}">note : {{getData.note}}</li>
          </ul>
           <ul v-id="getData.msg">
            <li v-for="(item, index) in getData.msg" v-bind:key="index">
              {{ item }}
            </li>
          </ul>
          <ul>
            <li v-for="(value, key) in getData.content" v-bind:key="key">
              {{ key }}: {{ value }}
            </li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click.prevent="close()">
            close
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
  export default {
    id: "#eventDialog",
    props: {
      data : {
        type: Object,
        required: true,
        default: function(){
          return {
            dialogData : {}
          }
        }
      },
      dialog: {
        type: Boolean
      }
    },
    computed: {
      getData() {
        return this.data || {};
      },
      getDialog(){
        return this.dialog;
      }
    },
    methods: {
      close() {
        this.$emit('closeDialog', false);
      }
    }

  }
</script>
<style scoped>
.headline{
    font-size: 12pt !important;
    color: #056e97;
    font-weight: bold;
    padding-bottom: 0;
}
.event_meta{
  margin-bottom: 15px !important;
}
.event_ok{
    color: #228a02 !important;
  }
  .event_error{
    color:#bd0303 !important;
  }

  .event_warning{
    color:#a9a400 !important;
  }

  .event_info{
    color: #20b8f2 !important;
  }
</style>


